import 'zone.js';

(window as any).global = window;
(window as any).process = {
  env: { NODE_ENV: 'production' },
  version: '',
};
(window as any).Buffer = (window as any).Buffer || require('buffer').Buffer;
